import React, { useEffect, useRef, useState } from "react";
import "../../Styles/Settings/EmailSetting.css";
import Actionbutton from "../../Assets/Actionbutton.png";
import folderbackicon from "../../Assets/folderbackicon.png";
import next_flow from "../../Assets/next_flow.png";
import caret_down from "../../Assets/caret-down.png";
import mail_notification from "../../Assets/mail_notification.png";
import activemail_notification from "../../Assets/activemail_notification.png";
import recipienticon from "../../Assets/recipienticon.png";
import activerecipienticon from "../../Assets/activerecipienticon.png";
import advancedIcon from "../../Assets/advancedIcon.png";
import activeadvancedIcon from "../../Assets/activeadvancedIcon.png";
import axios from "axios";
import { useParams } from "react-router-dom";

import editNotificationicon from "../../Assets/editNotificationicon.png";
import deleteNotificationIcon from "../../Assets/deleteNotificationIcon.png";
import close_icon from "../../Assets/closeIconPdf.png";
import pdfIcon from "../../Assets/pdfIcon.png";

const EmailSetting = () => {
  const [showDefaultOpeion, setShowDefaultOpeion] = useState(true);
  const [showNewTemplte, setNewTemplte] = useState(false);
  const [showNewMailOption, setShowNewMailOption] = useState("");


  const [showNotificationIcon, setNotificationIcon] = useState(null);
  const [emailSettings, setEmailSettings] = useState();
  const [selectedEmailSetting, setSelectedEmailSetting] = useState(null);
  const formId = useParams().formId;
  useEffect(() => {
    const getEmailSettings = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/forms/singleFormSettings/${formId}`
        );
        if (response.status === 200) {
          setEmailSettings(response.data.formEmailSetting);
          console.log(response.data.formEmailSetting)
        }
      } catch (error) {
        console.log(error);
      }
    };
    getEmailSettings();
  }, [formId]);

  const handelEditEmailNotification = (setting) => {
    if (setting.type === "Notification") {
      setShowDefaultOpeion(false);
      setShowNewMailOption("Notification email");
      setSelectedEmailSetting(setting);
    } else if (setting.type === "Autoresponder") {
      setShowDefaultOpeion(false);
      setShowNewMailOption("Autoresponder email");
    }
  };

  const handelDeleteEamilNotification = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API}/forms/deleteEmailSettings/${formId}/${id}`
      );
      if (response.status === 200) {
        setEmailSettings(response.data.formEmailSetting);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="email-setting-maincontainer">
        {showDefaultOpeion && (
          <>
            <div className="newmail-setting-container">
              <div>
                <div>NEW EMAIL</div>
                <div className="text-des">
                  Select an email type below to create your email.
                </div>
              </div>
              <button
                onClick={() => {
                  setNewTemplte(true);
                  setShowDefaultOpeion(false);
                }}
              >
                <img src={Actionbutton} alt="actionbutton" />
                Add Email
              </button>
            </div>
            {emailSettings?.map((emailSettings, index) => (
              <div
                className="default-created-email-settings"
                style={{
                  justifyContent: "space-between",
                  flexDirection: "row",
                  alignItems: "center",
                }}
                onMouseOver={() => setNotificationIcon(index)}
                onMouseLeave={() => setNotificationIcon(null)}
              >
                <div>
                  <div className="text-head">
                    {emailSettings.type} {index + 1}
                  </div>
                  <div className="text-des">
                    {emailSettings.senderName} - {emailSettings.recipientEmails}
                  </div>
                </div>
                {showNotificationIcon === index && (
                  <div style={{ display: "flex", gap: "1rem" }}>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => handelEditEmailNotification(emailSettings)}
                    >
                      <img src={editNotificationicon} alt="" />
                    </div>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handelDeleteEamilNotification(emailSettings.id)
                      }
                    >
                      <img src={deleteNotificationIcon} alt="" />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </>
        )}
        {showNewTemplte && (
          <div className="email-setting-maincontainer">
            <div className="newemail-setting-container">
              <div
                onClick={() => {
                  setNewTemplte(false);
                  setShowDefaultOpeion(true);
                }}
              >
                <img src={folderbackicon} alt="actionbutton" />
              </div>
              <div>
                <div>NEW EMAIL</div>
                <div className="text-des">
                  Select an email type below to create your email.
                </div>
              </div>
            </div>
            <div
              className="craete-templete-mail"
              onClick={() => {
                setShowNewMailOption("Notification email");
                setNewTemplte(false);
              }}
            >
              <div
                className="default-created-email-settings "
                style={{ border: "0px" }}
              >
                <div className="text-head">NOTIFICATION EMAIL</div>
                <div className="text-des">
                  Receive an email when someone fill out your form
                </div>
              </div>
              <img src={next_flow} alt="" />
            </div>
            <div
              className="craete-templete-mail"
              onClick={() => {
                setShowNewMailOption("Autoresponder email");
                setNewTemplte(false);
              }}
            >
              <div
                className="default-created-email-settings"
                style={{ border: "0px" }}
              >
                <div className="text-head">AUTORESPONDES EMAIL</div>
                <div className="text-des">
                  Send on email to the person who fills out your form
                </div>
              </div>
              <img src={next_flow} alt="" />
            </div>
            <div
              className="craete-templete-mail"
              onClick={() => setShowNewMailOption("Digest email")}
            >
              <div
                className="default-created-email-settings"
                style={{ border: "0px" }}
              >
                <div className="text-head">Digest email DIGEST EMAIL</div>
                <div className="text-des">
                  Receive an email when someone fill out your form
                </div>
              </div>
              <img src={next_flow} alt="" />
            </div>
          </div>
        )}
        {showNewMailOption === "Notification email" && (
          <NotificationEmail
            notificationSetting={emailSettings[0]}
            setShowNewMailOption={setShowNewMailOption}
            //emailSetting
            emailSettings={emailSettings}
            setEmailSettings={setEmailSettings}
            selectedEmailSetting={selectedEmailSetting}
            setSelectedEmailSetting={setSelectedEmailSetting}
            setShowDefaultOpeion={setShowDefaultOpeion}
            setNewTemplte={setNewTemplte}
          />
        )}
        {showNewMailOption === "Autoresponder email" && (
          <AutoResponserEmail
            setNewTemplte={setNewTemplte}
            selectedEmailSetting={selectedEmailSetting}
            setSelectedEmailSetting={setSelectedEmailSetting}
            setShowNewMailOption={setShowNewMailOption}
            setShowDefaultOpeion={setShowDefaultOpeion}
          />
        )}
      </div>
    </>
  );
};

const NotificationEmail = ({
  setShowNewMailOption,

  selectedEmailSetting,
  setSelectedEmailSetting,

  setShowDefaultOpeion,
  setNewTemplte,
}) => {
  const [showEmailNotification, setEmailNotification] = useState("Email");

  const defaultSelectedEmailSetting = {
    type: "Notification",
    emailSubject: "New Notification",
    senderName: "STACIA FORM",
    recipientEmailAddress: ["example@example.com"],
    sendEmailSubmit: true,
    sendEmailSubmitEdit: false,
    fileAtchment: true,
    hidenEmptyFile: false,
    senderEmail: "noreplay@staciacorp.com",
  };
  const [notificationEmailModel, setNotificationModel] = useState(
    selectedEmailSetting === null
      ? defaultSelectedEmailSetting
      : selectedEmailSetting
  );

  const formId = useParams().formId;
  const handelSaveEmailSetting = async () => {
    const generalSettingValue = {
      value: notificationEmailModel,
      type: "emailSettings",
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/forms/singleFormSetting/${formId}`,
        generalSettingValue
      );
      if (response.status === 200) {
        setNewTemplte(false);
        setShowNewMailOption("");
        setSelectedEmailSetting(null);
        setShowDefaultOpeion(true);
      }
    } catch (error) {
      console.error(error.message);
    }
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <div className="newemail-setting-container">
        <div
          onClick={() => {
            setNewTemplte(true);
            setShowNewMailOption("");
          }}
        >
          <img src={folderbackicon} alt="actionbutton" />
        </div>
        <div>
          <div>NOTIFICATION EMAIL</div>
          <div className="text-des">
            Receive an email when someone fill out your form
          </div>
        </div>
      </div>
      <div className="typeofemail-container">
        <div className="typeof-list-email-notification">
          <div
            onClick={() => setEmailNotification("Email")}
            style={{
              display: "flex",
              gap: "0.5rem",
              color: showEmailNotification === "Email" ? "#1B51BB" : " #8493B2",
              fontFamily:
                showEmailNotification === "Email" ? "EuclidSemiBold" : "",
            }}
          >
            {showEmailNotification === "Email" ? (
              <img
                src={activemail_notification}
                alt="activemail_notification"
              />
            ) : (
              <img src={mail_notification} alt="mail_notification" />
            )}
            Email
          </div>
          <div
            onClick={() => setEmailNotification("Recipient")}
            style={{
              display: "flex",
              gap: "0.5rem",
              color:
                showEmailNotification === "Recipient" ? "#1B51BB" : " #8493B2",
              fontFamily:
                showEmailNotification === "Recipient" ? "EuclidSemiBold" : "",
            }}
          >
            {showEmailNotification === "Recipient" ? (
              <img src={activerecipienticon} alt="activemail_notification" />
            ) : (
              <img src={recipienticon} alt="mail_notification" />
            )}
            Recipient
          </div>
          <div
            onClick={() => setEmailNotification("Advanced")}
            style={{
              display: "flex",
              gap: "0.5rem",
              color:
                showEmailNotification === "Advanced" ? "#1B51BB" : " #8493B2",
              fontFamily:
                showEmailNotification === "Advanced" ? "EuclidSemiBold" : "",
            }}
          >
            {showEmailNotification === "Advanced" ? (
              <img src={activeadvancedIcon} alt="activemail_notification" />
            ) : (
              <img src={advancedIcon} alt="mail_notification" />
            )}
            Advanced
          </div>
        </div>
        {showEmailNotification === "Email" && (
          <div className="email-subject-container email-setting-for-notification-settings">
            <div className="email-subject-contianer-input">
              <div>Email subject</div>
              <input
                className="email-subject-container-input"
                placeholder="Enter Subject"
                value={notificationEmailModel.emailSubject}
                onChange={(e) =>
                  setNotificationModel({
                    ...notificationEmailModel,
                    emailSubject: e.target.value,
                  })
                }
              />
              <div className="email-subject-container-p">
                Enter a name for your form
              </div>
            </div>
            <div className="previewfiled-form-container">
              <div className="model-form-send-email-user">
                <div className="form-container-title">Surveyor Form</div>
                <div className="form-container-description">
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen book. Lorem Ipsum has
                  been the industry's standard dummy text ever since the 1500s,
                  when an unknown printer took a galley of type and scrambled it
                  to make a type specimen book.
                </div>
                <hr />
                <div className="question-container-for-emailmodel">
                  <div>
                    1. Lorem Ipsum has been the industry's standard dummy text
                    ever since the 1500s
                  </div>
                  <div
                    style={{
                      paddingLeft: "0.5rem",
                      borderBottom: "1px solid #d3dce5",
                    }}
                  >
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showEmailNotification === "Recipient" && (
          <>
            <div className="email-subject-container Recipient">
              <div>
                <div>Sender name </div>
                <input
                  type="text"
                  name="senderName"
                  value={notificationEmailModel.senderName}
                  onChange={(e) =>
                    setNotificationModel({
                      ...notificationEmailModel,
                      senderName: e.target.value,
                    })
                  }
                />
              </div>

              <div>
                <div>Recipient Email</div>
                <input
                  type="email"
                  value={notificationEmailModel.recipientEmailAddress}
                  onChange={(e) =>
                    setNotificationModel({
                      ...notificationEmailModel,
                      recipientEmailAddress: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </>
        )}
        {showEmailNotification === "Advanced" && (
          <div className="email-subject-container Recipient">
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className="text-head">Send Email Automatically</div>
                <div className="text-des">
                  Automatically trigger the email when a specific action occurs
                </div>
              </div>
              <div></div>
            </div>
            <div className="submission-recive-type">
              <div
                style={{ display: "flex", gap: "1rem", alignItems: "center" }}
              >
                <input
                  type="checkBox"
                  style={{ width: "auto" }}
                  checked={notificationEmailModel.sendEmailSubmit}
                  onChange={(e) =>
                    setNotificationModel({
                      ...notificationEmailModel,
                      sendEmailSubmit: e.target.checked,
                    })
                  }
                />
                <div>When a submission is received</div>
              </div>
              <div
                style={{ display: "flex", gap: "1rem", alignItems: "center" }}
              >
                <input
                  type="checkbox"
                  style={{ width: "auto" }}
                  name="sendEmailSubmitEdit"
                  checked={notificationEmailModel.sendEmailSubmitEdit}
                  onChange={(e) =>
                    setNotificationModel({
                      ...notificationEmailModel,
                      sendEmailSubmitEdit: e.target.checked,
                    })
                  }
                />
                <div>When a submission is edited</div>
              </div>
            </div>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className="text-head">
                  Send File Uploads as Attachments
                </div>
                <div className="text-des">
                  Attach files uploaded through your form to this email
                </div>
              </div>
              <label className="form-setting-switch">
                <input
                  type="checkbox"
                  name="fileAtchment"
                  checked={notificationEmailModel.fileAtchment}
                  onChange={(e) =>
                    setNotificationModel({
                      ...notificationEmailModel,
                      fileAtchment: e.target.checked,
                    })
                  }
                />
                <span className="form-setting-slider form-setting-round"></span>
              </label>
            </div>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className="text-head">Hide Empty Fields</div>
                <div className="text-des">
                  Don't show unanswered fields in email
                </div>
              </div>
              <label className="form-setting-switch">
                <input
                  type="checkbox"
                  name="isQuiz"
                  checked={notificationEmailModel.hidenEmptyFile}
                  onChange={(e) =>
                    setNotificationModel({
                      ...notificationEmailModel,
                      hidenEmptyFile: e.target.checked,
                    })
                  }
                />
                <span className="form-setting-slider form-setting-round"></span>
              </label>
            </div>
            <div
              className="encrypt-data-container"
              style={{
                flexDirection: "column",
                gap: "0.5rem",
                justifyContent: "start",
                alignItems: "flex-start",
              }}
            >
              <div className="text-container-setting">
                <div className="text-head">Sender Email</div>
                <div className="text-des">
                  Select an email address to show as the sender
                </div>
              </div>
              <input
                className="encrypt-data-container-input"
                style={{ padding: "10px 1rem" }}
                name="senderEmail"
                value={notificationEmailModel.senderEmail}
                onChange={(e) =>
                  setNotificationModel({
                    ...notificationEmailModel,
                    senderEmail: e.target.value,
                  })
                }
              />
            </div>
          </div>
        )}
      </div>

      <hr style={{ marginTop: "1rem" }} />
      <div className="saveBtn-EmailSetting">
        <button onClick={handelSaveEmailSetting}>Save</button>
      </div>
    </div>
  );
};

const AutoResponserEmail = ({
  setNewTemplte,
  setShowNewMailOption,
  selectedEmailSetting,
  setSelectedEmailSetting,
  setShowDefaultOpeion,
}) => {
  const [showEmailNotification, setEmailNotification] = useState("Email");
  const [showDropDown, setDropDown] = useState(false);
  const formId = useParams().formId;

  const defaultSelectedEmailSetting = {
    type: "Autoresponder",
    emailSubject: "New Autoresponder",
    senderName: "STACIA FORM",
    replayToEmail: "example@example.com",
    sendEmailSubmit: true,
    sendEmailSubmitEdit: false,
    sendEmailAtTime: { label: "At Day Later", date: "" },

    fileAtchment: false,
    attachPdf: "",
    hideEmptyFields: false,
    senderEmail: "noreplay@staciacorp.com",
  };

  const [autoResponseData, setAutoResponse] = useState(
    selectedEmailSetting === null
      ? defaultSelectedEmailSetting
      : selectedEmailSetting
  );

  const timePriod = [
    { label: "At Day Later", value: { days: 0 } },
    { label: "1 day", value: { days: 1 } },
    { label: "2 day", value: { days: 2 } },
    { label: "5 day", value: { days: 5 } },
    { label: "8 day", value: { days: 8 } },
    { label: "10 day", value: { days: 10 } },
    { label: "20 day", value: { days: 20 } },
    { label: "30 day", value: { days: 30 } },
  ];

  // Function to calculate the adjusted date and time
  const calculateDateTime = ({ days }) => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + days); // Add days
    return currentDate.toLocaleString(); // Return ISO string (includes both date and time)
  };

  const handleSelectDate = (time) => {
    const selectedDate = calculateDateTime(time.value);
    setAutoResponse({
      ...autoResponseData,
      sendEmailAtTime: { label: time.label, date: new Date(selectedDate) },
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate(); // Get the day
    const month = date.toLocaleString("default", { month: "short" }); // Get the abbreviated month
    const year = date.getFullYear(); // Get the year

    return `${day} ${month} ${year}`;
  };

  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setAutoResponse({
        ...autoResponseData,
        attachPdf: file,
        fileAtchment: true,
      });
    }
  };

  const handelSaveButton = async () => {
    const generalSettingValue = {
      value: autoResponseData,
      type: "emailSettings",
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/forms/singleFormSetting/${formId}`,
        generalSettingValue
      );
      if (response.status === 200) {
        setNewTemplte(false);
        setShowNewMailOption("");
        setSelectedEmailSetting(null);
        setShowDefaultOpeion(true);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <div className="newemail-setting-container">
        <div
          onClick={() => {
            setNewTemplte(true);
            setShowNewMailOption("");
          }}
        >
          <img src={folderbackicon} alt="actionbutton" />
        </div>
        <div>
          <div>AUTORESPONDER 1</div>
          <div className="text-des">
            Send an email to the person who fills out your form
          </div>
        </div>
      </div>
      <div className="typeofemail-container">
        <div className="typeof-list-email-notification">
          <div
            onClick={() => setEmailNotification("Email")}
            style={{
              display: "flex",
              gap: "0.5rem",
              color: showEmailNotification === "Email" ? "#1B51BB" : " #8493B2",
              fontFamily:
                showEmailNotification === "Email" ? "EuclidSemiBold" : "",
            }}
          >
            {showEmailNotification === "Email" ? (
              <img
                src={activemail_notification}
                alt="activemail_notification"
              />
            ) : (
              <img src={mail_notification} alt="mail_notification" />
            )}
            Email
          </div>
          <div
            onClick={() => setEmailNotification("Recipient")}
            style={{
              display: "flex",
              gap: "0.5rem",
              color:
                showEmailNotification === "Recipient" ? "#1B51BB" : " #8493B2",
              fontFamily:
                showEmailNotification === "Recipient" ? "EuclidSemiBold" : "",
            }}
          >
            {showEmailNotification === "Recipient" ? (
              <img src={activerecipienticon} alt="activemail_notification" />
            ) : (
              <img src={recipienticon} alt="mail_notification" />
            )}
            Recipient
          </div>
          <div
            onClick={() => setEmailNotification("Advanced")}
            style={{
              display: "flex",
              gap: "0.5rem",
              color:
                showEmailNotification === "Advanced" ? "#1B51BB" : " #8493B2",
              fontFamily:
                showEmailNotification === "Advanced" ? "EuclidSemiBold" : "",
            }}
          >
            {showEmailNotification === "Advanced" ? (
              <img src={activeadvancedIcon} alt="activemail_notification" />
            ) : (
              <img src={advancedIcon} alt="mail_notification" />
            )}
            Advanced
          </div>
        </div>
        {showEmailNotification === "Email" && (
          <div className="email-subject-container email-setting-for-notification-settings">
            <div className="email-subject-contianer-input">
              <div>Email subject</div>
              <input
                className="email-subject-container-input"
                placeholder="Enter Subject"
                value={autoResponseData.emailSubject}
                onChange={(e) =>
                  setAutoResponse({
                    ...autoResponseData,
                    emailSubject: e.target.value,
                  })
                }
              />
              <div className="email-subject-container-p">
                Enter a name for your form
              </div>
            </div>
            <div className="previewfiled-form-container">
              <div className="model-form-send-email-user">
                <div className="form-container-title">Surveyor Form</div>
                <div className="form-container-description">
                  Lorem Ipsum has been the industry's standard dummy text ever
                  since the 1500s, when an unknown printer took a galley of type
                  and scrambled it to make a type specimen book. Lorem Ipsum has
                  been the industry's standard dummy text ever since the 1500s,
                  when an unknown printer took a galley of type and scrambled it
                  to make a type specimen book.
                </div>
                <hr />
                <div className="question-container-for-emailmodel">
                  <div>
                    1. Lorem Ipsum has been the industry's standard dummy text
                    ever since the 1500s
                  </div>
                  <div
                    style={{
                      paddingLeft: "0.5rem",
                      borderBottom: "1px solid #d3dce5",
                    }}
                  >
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showEmailNotification === "Recipient" && (
          <>
            <div className="email-subject-container Recipient">
              <div>
                <div>Sender name </div>
                <input
                  value={autoResponseData.senderName}
                  onChange={(e) =>
                    setAutoResponse({
                      ...autoResponseData,
                      senderName: e.target.value,
                    })
                  }
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: ".5rem",
                }}
              >
                <div>Replay- to- email</div>
                <div className="recipientEmailid">
                  {autoResponseData.replayToEmail}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: ".5rem",
                }}
              >
                <div>Recipient Email</div>
                <div className="recipientEmailid">SEND TO RESPONDERS EMAIL</div>
              </div>
            </div>
          </>
        )}
        {showEmailNotification === "Advanced" && (
          <div className="email-subject-container Recipient">
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className="text-head">Send Email Automatically</div>
                <div className="text-des">
                  Automatically trigger the email when a specific action occurs
                </div>
              </div>
              <div></div>
            </div>
            <div className="submission-recive-type">
              <div style={{ display: "flex", gap: "1rem" }}>
                <input
                  type="checkBox"
                  style={{ width: "auto" }}
                  checked={autoResponseData.sendEmailSubmit}
                  onChange={(e) =>
                    setAutoResponse({
                      ...autoResponseData,
                      sendEmailSubmit: e.target.checked,
                    })
                  }
                />
                <div>When a submission is received</div>
              </div>
              <div style={{ display: "flex", gap: "1rem" }}>
                <input
                  type="checkbox"
                  style={{ width: "auto" }}
                  checked={autoResponseData.sendEmailSubmitEdit}
                  onChange={(e) =>
                    setAutoResponse({
                      ...autoResponseData,
                      sendEmailSubmitEdit: e.target.checked,
                    })
                  }
                />
                <div>When a submission is edited</div>
              </div>
            </div>
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className="text-head">Send Email Later</div>
                <div className="text-des">
                  Choose to send this email instantly upon submission, or at a
                  later date
                </div>
              </div>
              <div
                className="sender-email-time-input"
                onClick={() => setDropDown(!showDropDown)}
              >
                {autoResponseData.sendEmailAtTime.label}
                <div>
                  <img src={caret_down} alt="caret-down" />
                </div>
                {showDropDown && (
                  <div className="SendEmailLater-container">
                    <ul>
                      {timePriod.map((time, i) => (
                        <li key={i} onClick={() => handleSelectDate(time)}>
                          {time.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            {autoResponseData.sendEmailAtTime.label !== "At Day Later" && (
              <div
                style={{
                  padding: "8px 1rem",
                  border: "1px solid #d3dce5",
                  borderRadius: "8px",
                  height: "2.5rem",
                }}
              >
                {formatDate(autoResponseData.sendEmailAtTime.date)}
              </div>
            )}
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className="text-head">Attach PDF</div>
                <div className="text-des">
                  Select PDFs to attach to this email
                </div>
              </div>
              <label className="form-setting-switch">
                <input
                  type="checkbox"
                  name="fileAtchment"
                  checked={autoResponseData.fileAtchment}
                  onChange={(e) =>
                    setAutoResponse({
                      ...autoResponseData,
                      fileAtchment: e.target.checked,
                    })
                  }
                />
                <span className="form-setting-slider form-setting-round"></span>
              </label>
            </div>
            {autoResponseData.fileAtchment && !autoResponseData.attachPdf && (
              <>
                <button
                  onClick={handleButtonClick}
                  className="AttcahPdf-container"
                >
                  Upload PDF
                </button>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  accept=".pdf"
                  onChange={handleFileChange}
                />
              </>
            )}
            {autoResponseData.fileAtchment && autoResponseData.attachPdf && (
              <div
                className="AttcahPdf-container"
                style={{ justifyContent: "start" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    backgroundColor: "rgba(27, 81, 187, 0.1)",
                    padding: "0.5rem 1rem",
                    borderRadius: "0.5rem",
                  }}
                >
                  <img src={pdfIcon} alt="pdfIcon" />
                  {autoResponseData.attachPdf.name}
                </div>
                <img
                  src={close_icon}
                  alt="close_icon"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setAutoResponse({
                      ...autoResponseData,
                      fileAtchment: true,
                      attachPdf: "",
                    })
                  }
                />
              </div>
            )}
            {/* <div
              className="encrypt-data-container"
              style={{
                flexDirection: "column",
                gap: "0.5rem",
                justifyContent: "start",
                alignItems: "flex-start",
              }}
            >
              <div className="text-container-setting">
                <div className="text-head">Enable pdf password</div>
                <div className="text-des">Secure your PDF with a password.</div>
              </div>
              <input
                className="encrypt-data-container-input"
                style={{ padding: "10px 1rem" }}
                placeholder="Enter Fle Password"
              />
            </div> */}
            <div className="encrypt-data-container">
              <div className="text-container-setting">
                <div className="text-head">Hide Empty Fields</div>
                <div className="text-des">
                  Don't show unanswered fields in email
                </div>
              </div>
              <label className="form-setting-switch">
                <input
                  type="checkbox"
                  name="fileAtchment"
                  checked={autoResponseData.hideEmptyFields}
                  onChange={(e) =>
                    setAutoResponse({
                      ...autoResponseData,
                      hideEmptyFields: e.target.checked,
                    })
                  }
                />
                <span className="form-setting-slider form-setting-round"></span>
              </label>
            </div>
            <div
              className="encrypt-data-container"
              style={{
                flexDirection: "column",
                gap: "0.5rem",
                justifyContent: "start",
                alignItems: "flex-start",
              }}
            >
              <div className="text-container-setting">
                <div className="text-head">Sender Email</div>
                <div className="text-des">
                  Select an email address to show as the sender
                </div>
              </div>
              <input
                className="encrypt-data-container-input"
                style={{ padding: "10px 1rem" }}
                value={autoResponseData.senderEmail}
                onChange={(e) =>
                  setAutoResponse({
                    ...autoResponseData,
                    senderEmail: e.target.value,
                  })
                }
              />
            </div>
          </div>
        )}
      </div>
      <hr style={{ marginTop: "1rem" }} />
      <div className="saveBtn-EmailSetting">
        <button onClick={handelSaveButton}>Save</button>
      </div>
    </div>
  );
};
// const DigestEmail = () => {
//   return <div></div>;
// };
export default EmailSetting;
